const Error401 = ({ data }: { data?: any }) => {
  return (
    <div>
      <h1>Unauthorized</h1>
      {data && <code>{data}</code>}
    </div>
  );
};

export default Error401;
